module.exports = __webpack_public_path__ + "static/media/applepay.1d19ac9f.svg";